import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentPatientProvider, PreOpProvider, PreOpResults as PreOpResultsUi, Spinner, } from "@madmedical/ui";
import { adaptPatient, usePatient } from "@madmedical/user";
import { addDays, invariant } from "@madmedical/utils";
import { useGetMeasurementRangeQuery } from "@madmedical/measurement";
import { MetricType } from "@madmedical/medical";
import { skipToken } from "@madmedical/store";
import { useCallback } from "react";
import { useGetLatestQuestionnaireQuery } from "../api";
import adaptQuestionnaire from "../adaptQuestionnaire";
const dayRange = (start) => ({
    from: start,
    to: addDays(1, new Date(start)).toISOString(),
});
const PreOpResults = () => {
    var _a, _b;
    const { patientId, patient, isLoading: isPatientLoading, } = usePatient();
    const { data: questionnaire, isLoading: isQuestionnaireLoading } = useGetLatestQuestionnaireQuery({ patientId });
    const getArgs = useCallback((metricType) => {
        const dateRange = questionnaire
            ? dayRange(questionnaire.createdAt)
            : undefined;
        return dateRange
            ? {
                userId: patientId,
                metricType,
                queryRange: dateRange,
                statsRange: dateRange,
            }
            : skipToken;
    }, [patientId, questionnaire]);
    const { data: bodyWeights, isLoading: isWeightsLoading } = useGetMeasurementRangeQuery(getArgs(MetricType.BodyWeight));
    const { data: bodyHeights, isLoading: isHeightsLoading } = useGetMeasurementRangeQuery(getArgs(MetricType.BodyHeight));
    if (isPatientLoading ||
        isQuestionnaireLoading ||
        isWeightsLoading ||
        isHeightsLoading) {
        return _jsx(Spinner, {});
    }
    invariant(questionnaire);
    invariant(patient);
    invariant(bodyWeights);
    invariant(bodyHeights);
    return (_jsx(CurrentPatientProvider, Object.assign({ value: { patient: adaptPatient(patient) } }, { children: _jsx(PreOpProvider, Object.assign({ value: { questionnaire: adaptQuestionnaire(questionnaire) } }, { children: _jsx(PreOpResultsUi, { bodyWeight: (_a = bodyWeights.items[0]) === null || _a === void 0 ? void 0 : _a.metric, bodyHeight: (_b = bodyHeights.items[0]) === null || _b === void 0 ? void 0 : _b.metric }) })) })));
};
export default PreOpResults;
